import * as constants from './constants';

export const monitoringInitialState = {
  filters: null,
  pathLocations: null,
  pathSpeed: null,
  stopLocations: null,
};

const monitoringReducer = (
  state = monitoringInitialState,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.GET_MONITORING_DATA:
      return {
        ...state,
        ...payload,
      };
    case constants.SET_MONITORING_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...payload },
      };
    case constants.GET_MONITORING_LOCATIONS:
      return {
        ...state,
        pathLocations: payload,
      };
    case constants.GET_MONITORING_PATH_SPEED:
      return {
        ...state,
        pathSpeed: payload,
      };
    case constants.GET_MONITORING_STOP_LOCATIONS:
      return {
        ...state,
        stopLocations: payload,
      };
    default:
      return state;
  }
};

export default monitoringReducer;
